import script from "./chart_alpha.vue?vue&type=script&setup=true&lang=js"
export * from "./chart_alpha.vue?vue&type=script&setup=true&lang=js"

import "./chart_alpha.vue?vue&type=style&index=0&id=44856f9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44856f9f"]])

export default __exports__